/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import { StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

// Component Imports
import { studentInfo } from '../../../../utils/static-data/studentInfo'
import Footnote from '../../../elements/Footnote'

// other

const WhatToLookFor = ({ className }) => (
  <div className={`${className} py-9`}>
    <div className="container">
      <div className="h2 blue text-center">Why Choose UMA?</div>
      <div className="row pt-5">
        <div className="col-12 col-lg-6 list-style-ascii-chevron">
          <p>
            Ultimate Medical Academy has supported over 75,000 students through graduation and beyond, but while you're
            at UMA you won't feel like just another number. Our online healthcare programs’ virtual classrooms have a
            maximum size of 25 students, with resources designed for students like you.
          </p>
          <p>
            <strong>When you pursue an online education from UMA, you'll:</strong>
          </p>
          <ul>
            <li>Gain a foundation for your career path</li>
            <li>Have a staff dedicated to your academic success every step of the way</li>
            <li>Work with a career services team committed to helping your career search</li>
            <li>Receive one-on-one academic support on coursework and course concepts</li>
            <li>Get access to online resources such as eBooks, medical journals, and reference articles</li>
            <li>Have access to certification/licensure exam preparation, if applicable to your program</li>
          </ul>
          <p>
            Our programs also include 24/7 tech support that helps you become comfortable with computers and in the
            online courseroom. When you hit a technical roadblock, UMA wants to help.
          </p>
        </div>
        <div className="col-12 col-lg-6 mt-5">
          <StaticImage src="../../../../assets/images/campus/online-campus-notetaking.jpg" alt="" />

          <div className="h2 blue">Continuing Your Education After UMA</div>
          <p>
            Everyone's journey starts somewhere. Yours doesn't have to end at the entry-level career in the healthcare
            system that a UMA program will prepare you for — that may just be the beginning. You might be able to take
            that degree even further to reach your career goals. In some cases, individuals who've obtained an associate
            degree choose to further their educational pursuits. If you meet the requirements at a UMA partner school,
            you may be able to seek a bachelor of science degree, then in some cases a master’s degree, in a relevant
            field of study that may take your career to new heights in a healthcare setting.
            <Footnote
              content={
                '{{"shortcode": "footnote", "content": "Select credits may transfer at the discretion of the receiving institution."}}'
              }
            />
          </p>
          <p>
            At UMA, we maintain educational partnerships that can allow alumni with an associate degree in certain
            programs at UMA the opportunity to pursue additional degrees in select areas of study.
            <Footnote
              content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.partnerSchoolsAcceptance}"}}'}
            />{' '}
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default styled(WhatToLookFor)``

// TODO: Vertical spacing.
